export default __webpack_public_path__ + "static/media/card.ff333f10.svg";